<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
 
    <div class="top_bg">
      <div class="container_box">
        <div style="font-size: 32px;font-size: 50px;">营销工具介绍</div>
        <div style="font-size: 20px;margin-top: 20px;font-size: 20px;">灵活多样营销神器 全面精准快速拓客 营销工具 轻松拓客</div>
      </div>
    </div>
    <div>
      <div style="text-align: center;font-size: 30px;color: #000;margin-top: 48px;">营销拓客模式精准</div>
      <div style="font-size: 18px;color: #A9A9A9;text-align: center;margin-top: 12px;">裂变式营销利器 速度快 效果好 成本低！</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
    </div>
    <div class="changeone">
      <div :class="now==0?'chooseIndex':''" @click="setActiveItem(0)">
        <div style="margin-top: 3px;">拓客商城</div>
      </div>
      <div :class="now==1?'chooseIndex':''" @click="setActiveItem(1)">
        <div style="margin-top: 3px;">智能导购</div>
      </div>
      <div :class="now==2?'chooseIndex':''" @click="setActiveItem(2)">
        <div style="margin-top: 3px;">分销商城</div>
      </div>
      <!-- <div :class="cindex==4?'chooseIndex':''" @click="setIdex(4)">
        <div style="margin-top: 3px;">短信营销</div>
      </div> -->
    </div>
    <!-- 跑马灯 -->
    <div class="carousel_container">
      <el-carousel height="750px" :autoplay="false" type="card" ref="carousel" @change="changes"
        indicator-position="outside">
        <el-carousel-item>
          <div class="card_box" v-show="this.now==0">
            <div class="img_banner1">
              <img :src="img_banner1" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="main_title">
                <div class="member">
                  拓客商城
                </div>
              </div>
              <div class="index_text">
                强大的分销系统，满足多样化需求一键分销，自动分账，操作简便商品多渠道独立管理，库存、订单即时同步多种模式，提供定制化服务，满足多样化需求
              </div>
            </div>
            <div class="top_line"></div>
          </div>
          <div v-show="this.now!=0">
            <div class="card_box2" v-show="this.now==1">
              <div class="main_title2">拓客商城</div>
              <div class="subtitle2">Expansion shopping<br>mall</div>
              <div class="index_text2">
                强大的分销系统，满足多样化需求一键分销，自动分账，操作简便商品多渠道独立管理，库存，订单即时同步多种模式，提供定制化服务，满足多样化需求
              </div>
            </div>
            <div class="card_box3" v-show="this.now==2">
              <div class="main_title3">拓客商城</div>
              <div class="subtitle3">Expansion shopping<br>mall</div>
              <div class="index_text3">
                强大的分销系统，满足多样化需求一键分销，自动分账，操作简便商品多渠道独立管理，库存、订单即时同步多种模式，提供定制化服务，满足多样化需求
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="card_box" v-show="this.now==1">
            <div class="img_banner1">
              <img :src="img_banner1" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="main_title">
                <div class="member">
                  智能导购
                </div>
              </div>
              <div class="index_text">一键扫码，操作简单便捷，智能分析顾客兴趣话题，精准分析顾客信息，海量拓客、精准转化，阿里投资品质有保障</div>
            </div>
            <div class="top_line"></div>
          </div>
          <div v-show="this.now!=1">
            <div class="card_box2" v-show="this.now==2">
              <div class="main_title2">智能导购</div>
              <div class="subtitle2">Wisdom Stores</div>
              <div class="index_text2">
                一键扫码，操作简单便捷，智能分析顾客兴趣话题，精准分析顾客信息，海量拓客、精准转化，阿里投资品质有保障
              </div>
            </div>
            <div class="card_box3" v-show="this.now==0">
              <div class="main_title3">智能导购</div>
              <div class="subtitle3">Wisdom Stores</div>
              <div class="index_text3">      
                一键扫码，操作简单便捷，智能分析顾客兴趣话题，精准分析顾客信息，海量拓客、精准转化，阿里投资品质有保障
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="card_box" v-show="this.now==2">
            <div class="img_banner1">
              <img :src="img_banner1" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="main_title">
                <div class="member">
                  分销商城
                </div>
              </div>
              <div class="index_text">
                一键转发，低风险、高回报，自用省钱，分享赚钱;自动裂变、商城裂变、老带新口碑拓客,线上营销方式全覆盖,获客更高效业绩翻翻翻
              </div>
            </div>
            <div class="top_line"></div>
          </div>
          <div v-show="this.now!=2">
            <div class="card_box2" v-show="this.now==0">
              <div class="main_title2">分销商城</div>
              <div class="subtitle2">Distribution Mall</div>
              <div class="index_text2">
                一键转发，低风险、高回报，自用省钱，分享赚钱;自动裂变、商城裂变、老带新口碑拓客,线上营销方式全覆盖,获客更高效业绩翻翻翻
              </div>
            </div>
            <div class="card_box3" v-show="this.now==1">
              <div class="main_title3">分销商城</div>
              <div class="subtitle3">Distribution Mall</div>
              <div class="index_text3">
                一键转发，低风险、高回报，自用省钱，分享赚钱;自动裂变、商城裂变、老带新口碑拓客,线上营销方式全覆盖,获客更高效业绩翻翻翻,
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 营销拓客模式精准 -->
    <div class="partone">
      <div style="font-size: 28px;color: #000;text-align: center;padding-top: 48px">营销拓客模式精准</div>
      <div style="font-size: 20px;color: #202020;text-align: center;margin-top: 12px">裂变式引流工具·全面化引流推广，轻松获取客源，实现在线消费
      </div>
      <div style="display: flex;align-items: flex-start;margin:0 auto;width:1200px;padding-top: 60px;">
        <div>
          <div style="margin-top:25px">
            <div class="zm1">获取客流</div>
            <div class="zm2">激活自有顾客池，通过成熟的营销模式，激活老客户与微信深度关联，基于完善的裂变营销，实现精准引流迅速拓客</div>
          </div>
          <div style="margin-top:30px">
            <div class="zm1">转化客户</div>
            <div class="zm2">顾客通过微信公众号、小程序、供应链，了解限时秒杀、办卡优惠、促销活动等优惠详情，提升消费频率，引导消费习惯</div>
          </div>
          <div style="margin-top:30px">
            <div class="zm1">专属商城</div>
            <div class="zm2">创建门店在线商城，顾客通过手机即可清楚了解店面产品及项目资讯，实现店面24小时营业，满足顾客随时购买的需求</div>
          </div>
          <div style="margin-top:30px">
            <div class="zm1">明星店铺</div>
            <div class="zm2">一对一服务，在线指导，帮您更好做线上运营，增加店铺粉丝量，提高店铺知名度，吸引线上客源，引导顾客到店消费</div>
          </div>
        </div>
        <div style="margin-left: 45px;width: 402px;height: 402px;">
          <img :src="photo" alt="" style="width: 100%;height: 100%;">
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        img_banner1: require('../../static/img/ic_tools.png'),
        photo: require('../../static/img/03.png'),
        cindex: 1,
        now: 0,
        scroll: '',
        scroll100: true,
        scroll700: false
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push('/')
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push('./home')
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push('./supplyChain')
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push('./marketingTools')
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push('./company')
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push('./channels')
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push('./contact')
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push('./culture')
      },
    //找美商学院-商学院文化
    goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      setIdex(item) {
        console.log(item)
        this.cindex = item
      },
      changes(a, b) {
        console.log('当前', a)
        // console.log('yuan',b)
        this.now = a

      },
      setActiveItem(index) {
        this.$refs.carousel.setActiveItem(index)
      },
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() {

    },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .top_bg {
    background-image: url('../../static/img/tools/tools.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 824px;
    position: relative;
    top: 0;
    left: 0;
  }

  .container_box {
    z-index: 1000;
    position: absolute;
    top: 38%;
    left: 0;
    color: #fff;
    text-align: center;
    min-width: 769px;
    width: 100%;
  }

  .changeone {
    display: flex;
    align-items: center;
    margin: 0 auto;
    justify-content: space-between;
    width: 393px;
    padding-top: 15px;
    cursor: pointer;
  }

  .chooseIndex {
    width: 87px;
    height: 28px;
    background: rgba(255, 203, 0, 1);
    border-radius: 14px;
    text-align: center;
    line-height: 22px;
  }

  .carousel_container {
    width: 1200px;
    height: 790px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 60px;
    position: relative;
    cursor: pointer;
  }

  .card_box {
    background: #F6F6F6;
    box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.12);
    width: 558px;
    /* height: 800px; */
    height: 750px;
  }

  .second_index {
    width: 548px;
    height: 790px;
    background: #fff;
    padding: 5px;
  }

  .img_banner1 {
    width: 548px;
    height: 480px;
    margin: 5px 5px 0 5px;
  }

  .img_box {
    width: 548px;
    /* height: 310px; */
    height: 260px;
    background:#fff;
    margin: 0 5px;
  }

  .main_title {
    width: 221px;
    height: 48px;
    background: rgba(245, 134, 53, 1);
    border-radius: 4px;
    text-align: center;
    font-size: 26px;
    color: #fff;
    position: absolute;
    top: 456px;
    left: 164px;
  }

  .member {
    margin-top: 5px;
  }

  .index_text {
    font-size: 20px;
    line-height: 33px;
    margin-left: 38px;
    color: #838383;
    /* padding-top: 83px; */
    padding-top: 53px;
    width: 480px;
    text-indent: 35px;
  }
  .top_line{
    /* background: #F58635;
    width: 558px;
    height: 5px; */
    border-bottom: 10px solid #F58635;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    width: 552px;
  }
  .card_box2 {
    width: 342px;
    height: 534px;
    background-color: #fff;
    box-shadow: 0px 2px 10px 2px #E4E4E4;
    margin-left: 130px;
    margin-top: 74px;
  }

  .card_box3 {
    width: 342px;
    height: 534px;
    background-color: #fff;
    box-shadow: 0px 2px 10px 2px #E4E4E4;
    position: relative;
    margin-left: 85px;
    margin-top: 74px;
  }

  .main_title2 {
    font-size: 26px;
    color: #303030;
    margin-left: 55px;
    padding-top: 84px;
  }

  .subtitle2 {
    font-size: 18px;
    color: #303030;
    margin: 7px 39px;
  }

  .index_text2 {
    font-size: 18px;
    color: #303030;
    text-indent: 35px;
    width: 170px;
    line-height: 25px;
    margin: 27px 31px;
  }

  .main_title3 {
    font-size: 26px;
    color: #303030;
    position: absolute;
    top: 84px;
    right: 70px;
  }

  .subtitle3 {
    font-size: 18px;
    color: #303030;
    position: absolute;
    top: 128px;
    right: 36px;
  }

  .index_text3 {
    font-size: 18px;
    color: #303030;
    text-indent: 35px;
    width: 170px;
    line-height: 25px;
    position: absolute;
    top: 180px;
    right: 30px;
  }

  .partone {
    width: 100%;
    height: 681px;
    background: rgba(252, 252, 254, 1);
    padding-bottom: 80px;
  }

  .zm1 {
    font-size: 24px;
    color: #2F2F2F;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .zm2 {
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #626262;
    margin-top: 10px;
    width: 746px;
    line-height: 25px;
  }
</style>


// WEBPACK FOOTER //
// src/page/marketingTools.vue